<style>
</style>

<!-- Now removing this link from the ng, because it's in the django base -->
<!-- <div class="emblem">Bojana<br/>Cvejić</div> -->

<div id="weathers">
  @for (place of weathers$ | async; track $index) {
    <place-of-weather
      [id]=place.id
      [dotLabel]=place.dot_label
      [date]=place.created_at
      [body]=place.body
      [bodyInBrs]=place.body_in_brs
      [left]=place.left
      [top]=place.top
      [detailURL]=place.detail_url
      >
    </place-of-weather>
    <!--  track place.sort_order -->
    <!--       (bumpToTop)="bumpToTop($event)" -->
  }
  @empty {
    <p class="none none-weather">Weatherless, nor good nor bad.</p>
  }
</div>
